import { render, staticRenderFns } from "./plogdetail.vue?vue&type=template&id=20902a2b&scoped=true&"
import script from "./plogdetail.vue?vue&type=script&lang=js&"
export * from "./plogdetail.vue?vue&type=script&lang=js&"
import style0 from "./plogdetail.vue?vue&type=style&index=0&id=20902a2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20902a2b",
  null
  
)

export default component.exports